import styled from 'styled-components';

// import safetyBack from '../../../assets/images/bg-prpl-red-dots.jpg';

import * as Text from '../../../../styles/shared/multibrand-typography';
import * as colors from '../../../../styles/shared/colors';
import { breakpoints, respondTo } from '../../../../styles/shared/breakpoints';
import { fadeIn } from '../../../../styles/shared/keyframes';
import Theme from "../../../../util/globals/Theme";

const INDICATIONS_AND_SAFETY_CONTAINER = 11;
const INDICATIONS_DRAWER_LAUNCH_BUTTON = 41;
const INDICATIONS_INFORMATION_DRAWER = 43;
const SAFETY_DRAWER_LAUNCH_BUTTON = 43;
const SAFETY_INFORMATION_DRAWER = 44;

const header_bump_out_padding = 6;

export const MultiBrandLaunchButtonContainer = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: ${INDICATIONS_AND_SAFETY_CONTAINER};
  display: flex;
  flex-flow: column nowrap;
  width: 100%;
  max-width: 1024px;
  margin: 0 auto;

  pointer-events: none;
  cursor: pointer;
  transform: ${({ isCollapsed }) => (isCollapsed ? 'translateY(100%)' : 'none')};
  transition: transform 0.3s ease-in-out;

  > * {
    pointer-events: auto;
  }
    .safetywrapper{
    height:122px;
    }

  ${respondTo.md`
    padding: 0 20px;
  `}
`;

export const MultiBrandLaunchButton = styled.div`
  
 @media (max-width:992px){
 padding: 10px 12px; 
 }
  border: 1px solid ${colors.silver};
  overflow: hidden;
  box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.1);
  background-color: ${colors.white};
  border-radius: 8px 8px 0 0;

  ${respondTo.md`
    box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.16);
    transition: transform 0.3s ease-in-out;

    &:hover {
      box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.25);
    }
  `}

  header {
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: flex-start;

  }

  &:hover header::after {
    background-color: ${colors.mist};
  }

  > div {
    overflow: hidden;
  }
`;

export const MultiBrandIndicationsLaunchButton = styled(MultiBrandLaunchButton)`
  z-index: ${INDICATIONS_DRAWER_LAUNCH_BUTTON};
   ${(props)=> props.isCollapsedFirst ? `
    height: 46px;
    ` :
    `
    height: 167px;
    `}
  margin-bottom: -10px;
  transition: height 0.3s ease-in-out, padding 0.3s ease-in-out;

  button {
      background-color: transparent;
      border: none;
      cursor: pointer;
  }
  
  @media (min-width: ${breakpoints.sm}px){
     padding: 10px 12px;
     ${(props)=> props.isCollapsedFirst ? `
       height: 46px;
      ` : 
      `
      height: 109px;
      `}
  }
`;


export const MultiBrandSafetyLaunchButton = styled(MultiBrandLaunchButton)`
  z-index: ${SAFETY_INFORMATION_DRAWER};
  height: 140px;
  margin-bottom: -5px;
  @media (min-width:555px){
  height:110px;
  }

${respondTo.md`
    height: 140px;
    width:100%;
  `}
  button {
      background-color: transparent;
      border: none;
      cursor: pointer;
  }

  ${respondTo.md`
    margin-bottom: 0px;
  `}

   .green-container{

    h6[class^='multibrand-typography__H6']{
      color: ${colors.black};
      margin-bottom: 4px;
      }
    ul[class^='multibrand-typography__Ul']{
      li{
        &::before{
          background-color: ${colors.lightGreen};
        }
      }
    }
  }
  .blue-container{
  h6[class^='multibrand-typography__H6']{
      margin-bottom: 4px;
  }
    ul[class^='multibrand-typography__Ul']{
      li{
        &::before{
          background-color: ${colors.brandBlueLight};
        }
      }
    }
  }
`;

export const MultiBrandPreviewTitle = styled.span`
  font-size: 20px;
  line-height: 18px;
  font-weight: 700;
  padding-bottom: 3px; 
  color: ${colors.ink3};
  @media (max-width:768px){
    font-size: 16px;
    letter-spacing: -0.48px;
  }
`;

export const MultiBrandPreviewText = styled(Text.Body)`
  line-height: 20px;
color: #000000;
font-weight: 400;

  strong {
    color: ${colors.weliregBlue};
    font-weight: 500;
  }
`;

export const MultiBrandCloseButton = styled.button`
  position: absolute;
  top: -5px;
  right: 0px;
  width: 36px;
  height: 36px;
  cursor: pointer;

  padding: 0;
  margin: 0;
  border: none;
  background-color: transparent;
  transition: 0.3s background-color;

  color: ${colors.white};
  font-size: 10px;
  font-weight: 700;
  padding-top: 28px;

  &:before,
  &:after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    display: inline-block;
    height: 18px;
    width: 3px;
    border-radius: 10px;
    background-color: ${colors.white};
  }
  &:before {
    transform: translate(-50%, -50%) rotate(45deg);
  }
  &:after {
    transform: translate(-50%, -50%) rotate(-45deg);
  }

  &:hover {

  }

  ${respondTo.sm`
    top: -5px;
    right: 0px;
    width: 36px;
    height: 32px;
    padding-top: calc(36px - 9px);
  `}
`;

export const MultiBrandDrawerHeader = styled.div`
  position: relative;
  padding: 12px 20px; 
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: ${({drawerName}) => drawerName !=="safety" ? 'center' : 'flex-start'};
  border-radius: 0px;
  background: linear-gradient(90deg, #2E3790 0.01%, #3F89C8 100%);

  ${respondTo.sm`
    padding: 12px 30px;
    border-radius: 10px 10px 0px 0px;
  `}

`;

export const MultiBrandDrawerHeaderText = styled(Text.H3)`
  color: ${colors.ink3};
  margin-bottom: 0;
  // max-width: 820px;
  width: 100%;
  padding: 30px 0px 12px;
   @media (max-width: ${Theme.breakpoints.md}px) {
    width:80%;
  }

`;
export const MultiBrandDrawerHeader2Text = styled(Text.H3)`
  color: ${colors.white};
  font-size:24px;
  display:block;
  margin-bottom:0px;
   br {
    display: none;
  }
  @media (max-width: ${Theme.breakpoints.md}px) {
      font-size:17px;
      width: 85%;
       br {
    display: block;
  }
  }
`;

export const MultiBrandModalButtonWrapper = styled.div`
    position: relative;
    height: 36px;
    width: 40px;
`;

export const MultiBrandDrawerSubheaderText = styled(Text.Subtitle)`
  display: inline-block;
  margin: 16px 0 0;
  padding: ${header_bump_out_padding}px 8px;
  border-radius: 4px;
  font-weight: 500;
  color: ${colors.white};
  background-color: ${colors.weliregBlue};
`;

export const MultiBrandInformationDrawer = styled.div`
  display: none;
  position: fixed;
  z-index: ${({ drawerName }) =>
    drawerName === 'indications' ? INDICATIONS_INFORMATION_DRAWER : SAFETY_INFORMATION_DRAWER};
  top: 100vh;
  left: 0;
  right: 0;
  flex-direction: column;
  height: 100%;
  max-width: 1024px;
  overflow: hidden;
  margin: 0 auto;
  cursor: auto;
  transition: 0.4s transform ease-in-out;

  > .container {
    background-color: ${colors.white};
    height: 100%;
    overflow: auto;
    padding: 30px 30px 34px 30px;
    [class^='multibrand-typography__Body']{
      padding: 0;
      height: auto;
    }
      [class^='multibrand-typography__Body']{
      line-height:20px
      }

    @media (max-width: ${breakpoints.mid}px){
      padding: 20px 20px;
      // margin-bottom: 230px;
      overflow: hidden;
    }
      
  }

  &.information-drawer-enter {
    transform: translateY(0);
    opacity: 1;
    display: flex;
  }

  &.information-drawer-enter-active,
  &.information-drawer-enter-done {
    transform: translateY(-100vh);
    opacity: 1;
    display: flex;
  }

  &.information-drawer-exit {
    transform: translateY(-100vh);
    display: flex;
  }

  &.information-drawer-exit-active,
  &.information-drawer-exit-done {
    transform: translateY(0);
    display: flex;
  }

  &.information-drawer-exit-done {
    opacity: 0;
    display: none;
  }
    .custom-key{
    overflow:auto;
   
}
    @media (max-width:1020px){
    .custom-key{
     height: calc(100vh - var(--blue-height) - var(--green-height) - 50px);
    }
    .custom-welireg{
    height: calc(100vh - 35px - var(--green-height) - var(--header-height));
    .spacing-expand{
        padding-bottom:100px;
        }
    }
        .custom-qlex{
        height: calc(100vh - 35px - var(--header-height));
        }
    .spacing-expand{
        padding-bottom:130px;
        }
    }

  ${respondTo.md`
    padding: 0 20px;
  `}

  .darkColor{
        color: ${colors.black};

        a{
         color: ${colors.brandBlueDark};
        }
      }
`;

export const MultiBrandDrawerOverlay = styled.div`
  position: fixed;
  z-index: ${INDICATIONS_AND_SAFETY_CONTAINER - 1};
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  height: 100vh;
  background-color: rgba(50,50,50, 0.7);
  display: ${({ isActive }) => (isActive ? 'block' : 'none')};
  animation: ${fadeIn} 0.5s;
  cursor: pointer;
`;

export const MultiBrandTwoCol =  styled.div`
    display: flex;
    [class^='styles__MultiBrandPreviewTitle']{
      padding-bottom: 4px;
      display: block;
    }
    .blue-container{
    padding: 0 12px 0 0;
    border-right: 1px solid ${colors.neutralsGrey};
     padding: 10px 12px;
    ${respondTo.sm`
      width:50%;
      `}
    ul[class^='multibrand-typography__Ul']{
          li{
            &::before{
              background-color: ${colors.brandBlueLight};
            }
          }
        }
    }
    .green-container{
      padding: 0 12px;
      padding-right: 0px;
      padding: 10px 12px;
      ${respondTo.sm`
      width:50%;
      `}
        h6[class^='multibrand-typography__H6']{
          color: ${colors.black};
          margin-bottom: 2px;
          letter-spacing: -0.16px;        
          }
        ul[class^='multibrand-typography__Ul']{
          li{
            &::before{
              background-color: ${colors.lightGreen};
            }
          }
        }
      }   
`